interface Color {
  hue: number
  light: number
  saturation: number
}

interface ColorPossibilities {
  primary?: string
  secondary?: string
}

function hexToHSL(H: string): Color {
  let red = 0
  let green = 0
  let blue = 0

  if (H.length == 4) {
    red = Number('0x' + H[1] + H[1])
    green = Number('0x' + H[2] + H[2])
    blue = Number('0x' + H[3] + H[3])
  } else if (H.length == 7) {
    red = Number('0x' + H[1] + H[2])
    green = Number('0x' + H[3] + H[4])
    blue = Number('0x' + H[5] + H[6])
  }

  red /= 255
  green /= 255
  blue /= 255

  const minimum = Math.min(red, green, blue)
  const maximum = Math.max(red, green, blue)
  const delta = maximum - minimum

  let hue = 0
  let saturation = 0
  let light = 0

  if (delta == 0) {
    hue = 0
  } else if (maximum == red) {
    hue = ((green - blue) / delta) % 6
  } else if (maximum == green) {
    hue = (blue - red) / delta + 2
  } else {
    hue = (red - green) / delta + 4
  }

  hue = Math.round(hue * 60)

  if (hue < 0) {
    hue += 360
  }

  light = (maximum + minimum) / 2
  saturation = delta == 0 ? 0 : delta / (1 - Math.abs(2 * light - 1))
  saturation = +(saturation * 100).toFixed(1)
  light = +(light * 100).toFixed(1)

  return { hue, saturation, light }
}

function generateVariants(color: Color) {
  const prefix = `hsla(${color.hue}, ${color.saturation}%,`

  return {
    main: `${prefix} ${color.light}%, 1)`,
    darker: `${prefix} ${Math.round(color.light * 0.75)}%, 1)`,
    dark: `${prefix} ${Math.round(color.light * 0.875)}%, 1)`,
    light: `${prefix} ${Math.round(color.light * 1.125)}%, 1)`,
    lighter: `${prefix} ${Math.round(color.light * 1.25)}%, 1)`,
    '20': `${prefix} ${color.light}%, 0.2)`,
    '15': `${prefix} ${color.light}%, 0.15)`,
    '10': `${prefix} ${color.light}%, 0.1)`,
  }
}

function setStyleVariables({ primary, secondary }: ColorPossibilities): void {
  const root = document.documentElement

  if (primary) {
    const values = generateVariants(hexToHSL(primary))

    root.style.setProperty('--color-primary-main', values.main)
    root.style.setProperty('--color-primary-darker', values.darker)
    root.style.setProperty('--color-primary-dark', values.dark)
    root.style.setProperty('--color-primary-light', values.light)
    root.style.setProperty('--color-primary-lighter', values.lighter)
    root.style.setProperty('--color-primary-20', values['20'])
    root.style.setProperty('--color-primary-15', values['15'])
    root.style.setProperty('--color-primary-10', values['10'])
  }

  if (secondary) {
    const values = generateVariants(hexToHSL(secondary))

    root.style.setProperty('--color-secondary-main', values.main)
    root.style.setProperty('--color-secondary-darker', values.darker)
    root.style.setProperty('--color-secondary-dark', values.dark)
    root.style.setProperty('--color-secondary-light', values.light)
    root.style.setProperty('--color-secondary-lighter', values.lighter)
    root.style.setProperty('--color-secondary-20', values['20'])
    root.style.setProperty('--color-secondary-15', values['15'])
    root.style.setProperty('--color-secondary-10', values['10'])
  }
}

export default setStyleVariables
